import { getDashboard } from '../../graphql/queries';
import {
  GET_DASHBOARD_REQUESTED,
  GET_DASHBOARD_COMPLETED,
  GET_DASHBOARD_FAILED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';

const addPlanOwnerLabelToPlans = (planOwners) =>
  planOwners.map((po) => ({
    ...po,
    Plans: po.Plans.map((p) => ({
      ...p,
      PlanOwnerLabel: po.Label,
    })),
  }));

// https://docs.amplify.aws/lib/graphqlapi/getting-started/q/platform/js#enable-queries-mutations-and-subscriptions
// https://docs.amplify.aws/cli/graphql-transformer/dataaccess
const getDashboardAction = (ContactID) => async (dispatch) => {
  dispatch({
    type: GET_DASHBOARD_REQUESTED,
  });

  try {
    const { data } = await api.graphql({
      query: getDashboard,
      variables: {
        ContactID,
      },
    });

    dispatch({
      type: GET_DASHBOARD_COMPLETED,
      payload: {
        ...data.getDashboard,
        planOwners: addPlanOwnerLabelToPlans(data.getDashboard.planOwners),
      },
    });
  } catch (err) {
    debug(GET_DASHBOARD_FAILED, err);

    dispatch({
      type: GET_DASHBOARD_FAILED,
      payload: err,
    });
  }
};

export default getDashboardAction;
